import Box from '@mui/material/Box';
import { Field, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { Container, LogoAlignedContainer } from './ContentBlock.styles';
import TextWithStudyPnMergeTag from '../shared/TextWithStudyPnMergeTag/TextWithStudyPnMergeTag';
import RichTextWithStudyPnMergeTag from '../shared/RichTextWithStudyPnMergeTag/RichTextWithStudyPnMergeTag';
import UiHeading from '../shared/Heading';
import useApplyV2Theme from '../../lib/hooks/useApplyV2Theme';

export type ContentBlockProps = ComponentProps & {
  fields?: {
    heading?: TextField;
    content?: Field<string>;
    alignedwithLogo?: Field<boolean>;
  };
};

/**
 * A simple Content Block component, with a heading and rich text block.
 * This is the most basic building block of a content site, and the most basic
 * JSS component that's useful.
 */

const ContentBlock = (props: ContentBlockProps): JSX.Element => {
  const { isToapplyV2Theme } = useApplyV2Theme();
  if (!props?.fields) return <></>;
  const { fields } = props;

  const heading = fields?.heading;
  const content = fields?.content;
  const isRightAligned = fields?.alignedwithLogo?.value;
  const Wrapper = isRightAligned ? LogoAlignedContainer : Container;

  return (
    <>
      {heading?.value || content?.value ? (
        <Wrapper id="content-block" className="ui-content-block">
          <Box className={isToapplyV2Theme && 'Study-section'}>
            {heading?.value && (
              <UiHeading size="h2" isChildren color="primary">
                <TextWithStudyPnMergeTag field={heading} inheritLinkColor={false} />
              </UiHeading>
            )}
            {content?.value && (
              <RichTextWithStudyPnMergeTag
                field={content}
                cssClassName={'contentblock-content'}
                inheritLinkColor={false}
              ></RichTextWithStudyPnMergeTag>
            )}
          </Box>
        </Wrapper>
      ) : null}
    </>
  );
};

export default ContentBlock;
